export { default } from "./CamposOutline";
